import axios from "axios";
import {
    Observable,
    concat
} from "rxjs";
import config from "../../config/config";
import Cookie from "cookies-js";
// const options = {
//     method: 'POST',
//     headers: { 'authorization': 'token' },
//     data: qs.stringify(data),
//     url,
// };
const https = require('https');
const agent = new https.Agent({  
    rejectUnauthorized: false
});

export const Login_service = {
    login,
    logout,
    forget,
    activate,
    resetPassword,
    ad_authenticate,
    ad_login,
    get_banner,
    update_banner
};

function login(data){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "admin/login" , data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function logout(token) {
    return Observable.create(observer => {
        axios.post(config.API_URL + 'admin/logout', {
                token: token
            }).then(result => {
                if (result.data.status === 200) {
                    observer.next(result.data.status);
                    observer.complete();
                } else if (result.data.status != 200) {
                    observer.error(result.data);
                    observer.complete();
                }
            })
            .catch(error => {
                observer.error(error);
            });
    });
}

function forget(data) {
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "admin/fogetPassword", data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function activate(data) {
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "activate/" + data.type + "/" + data.activate_token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function resetPassword(data) {
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "admin/resetPassword", data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function ad_authenticate(formdata){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + 'ad/authen', formdata, { httpsAgent: agent })
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function ad_login(formdata){
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL+'admin/adLogin', formdata)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function get_banner(type){
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL+'banner/getBanner',{params: {banner_type : type}})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function update_banner(formdata){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL+'banner/updateBanner/?authorization='+json_cookie.token, formdata)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}